module.exports = __webpack_public_path__ + "img/IMG_6070_L_Wood.09a29dc4.jpg";